module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/spinner-c4da2f8000d7cce07b4f11a0e63c0f7d.svg";